// Conditional field visibility. A field may declare
//   config.show_if = { field: "<key>", equals: "<value>" }
// and is only shown/required when that condition is met.
export function isFieldVisible(field, values) {
  const cond = field?.config?.show_if;
  if (!cond || !cond.field) return true;
  return (values || {})[cond.field] === cond.equals;
}

// Fields that are computed on read (never editable in forms).
export function isComputedField(field) {
  return field?.type === "rollup" || field?.type === "formula";
}
